export default (function (siteVariables) {
  return {
    iconColor: siteVariables.colors.grey[800],
    iconBackgroundColor: siteVariables.colors.brand[400]
  };
});
//# sourceMappingURL=avatarVariables.js.map
